import AtomIcon from './AtomIcon';
import BiographiesIcon from './BiographiesIcon';
import CivicsLibraryIcon from './CivicsLibraryIcon';
import GenericLibraryIcon from './GenericLibraryIcon';
import GlobeIcon from './GlobeIcon';
import HardHatIcon from './HardHatIcon';
import LawIcon from './LawIcon';
import PrimarySourceIcon from './PrimarySourceIcon';

type LibraryIcon = {
  Icon: (props: { ariaLabel?: string; color?: string; size?: number }) => JSX.Element;
  className?: string;
};

// AIDEV-NOTE: keyed on the library's tag, which is the library's identity — not on the assignable
// type, which is a token derived from the tag and free to change spelling (PLAT-14851). Content can
// add a library without a code change, so anything missing here falls back to GenericLibraryIcon.
const LIBRARY_ICONS_BY_TAG: Record<string, LibraryIcon> = {
  Biographies: { Icon: BiographiesIcon, className: 'tw-w-[125px]' },
  'Career Profiles': { Icon: HardHatIcon },
  'Civics Library': { Icon: CivicsLibraryIcon },
  Maps: { Icon: GlobeIcon },
  'Primary Source Library': { Icon: PrimarySourceIcon },
  'Science and Engineering Resources': { Icon: AtomIcon, className: 'tw-w-[50px]' },
  'Supreme Court Cases': { Icon: LawIcon, className: 'tw-w-[50px]' },
};

const GENERIC_LIBRARY_ICON: LibraryIcon = { Icon: GenericLibraryIcon };

export const libraryIconFor = (tag?: string | null): LibraryIcon => (
  (tag && LIBRARY_ICONS_BY_TAG[tag]) || GENERIC_LIBRARY_ICON
);

export default LIBRARY_ICONS_BY_TAG;
